import moment from 'moment';
import Swiper, { Navigation } from 'swiper';
import { urlParams, getFormattedTime } from "./utils/helpers";
import { API_KEY, HOST, DATES_INTERVAL } from "./utils/constants";

const myHeaders = new Headers();
myHeaders.append("Authorization", `Bearer ${API_KEY}`);
myHeaders.append("Accept", "application/json");

export default {
    data() {
        return {
            dateQueryParam: null,
            loading: true,
            error: '',
            fixturesData: [],
            currentSeason: '',
            // Datepicker
            today: '',
            dates: [],
            selectedDate: '',
            dateFormat: 'YYYY-MM-DD',
            dateReadableFormat: 'ddd, MMM DD',
            datepickerSwiper: null,
        }
    },
    computed: {
        selectedReadableDate() {
            return moment(this.selectedDate).format('ddd, MMM DD, YYYY',)
        },
    },
    methods: {
        getFormattedTime,
        getDateRange(interval) {
            // const now = moment();
            const dates = [];
            let date = null;
            let label = '';

            for (let i = -interval; i <= interval; i++) {
                if (i < 0) {
                    date = moment(this.today).subtract(-1 * i, 'days')
                    label = (i === -1) ? 'Yesterday' : date.format(this.dateReadableFormat)
                } else if (i > 0) {
                    date = moment(this.today).add(i, 'days')
                    label = (i === 1) ? 'Tomorrow' : date.format(this.dateReadableFormat)
                } else {
                    date = moment(this.today)
                    label = 'Today'
                }

                dates.push({
                    value: date.format(this.dateFormat),
                    label,
                });
            }

            return dates;
        },
        getFixtures() {
            if (!true) {
                // TODO: TEMP
                this.error = false
                this.loading = false

                this.fixturesData = [
                    {
                        "id": 37314,
                        "name": "Hamilton A. vs Van Eijden R.",
                        "status": "canceled",
                        "duration": 9000,
                        "league_id": 3276,
                        "season_id": 19014,
                        "start_time": "2009-10-30T19:00:00\u002B00:00",
                        "league_name": "European Darts Championship",
                        "season_name": "European Championship 2009",
                        "away_team_id": 266405,
                        "home_team_id": 47506,
                        "status_reason": "Canceled",
                        "tournament_id": 66472,
                        "away_team_name": "Van Eijden R.",
                        "home_team_name": "Hamilton A.",
                        "away_team_score": 3,
                        "home_team_score": 6,
                        "tournament_name": "European Championship",
                        "league_hash_image": "dce48e5a22edb035ca876820a31dab40157d96707c1f7e3e279749780b4762a9",
                        "away_team_hash_image": "9fe8183d144425ae4ebdf6df89cc6b01bf66e08ea97d91ec63d687a52660c326",
                        "home_team_hash_image": "04b5b0bad14b84fb3bcbc674bda358360555d93e0f64e0b2164f2ec3593b1545",
                        "tournament_importance": 0
                    },
                    {
                        "id": 37315,
                        "name": "Van Gerwen M. vs Van Der Voort V.",
                        "status": "finished",
                        "duration": 9000,
                        "league_id": 3276,
                        "season_id": 19014,
                        "start_time": "2009-10-30T19:00:00\u002B00:00",
                        "league_name": "European Darts Championship",
                        "season_name": "European Championship 2009",
                        "away_team_id": 47530,
                        "home_team_id": 1810,
                        "status_reason": "Ended",
                        "tournament_id": 66472,
                        "away_team_name": "Van Der Voort V.",
                        "home_team_name": "Van Gerwen M.",
                        "away_team_score": 2,
                        "home_team_score": 6,
                        "tournament_name": "European Championship",
                        "league_hash_image": "dce48e5a22edb035ca876820a31dab40157d96707c1f7e3e279749780b4762a9",
                        "away_team_hash_image": "a6b99fb3a6361f6aa6250aa24065d94718310b1b998d3e122b85709f4df66376",
                        "home_team_hash_image": "e5281230fc54252da40c3c86448cda06e2b5d422669f501044d58d18aec97b06",
                        "tournament_importance": 0
                    },
                    {
                        "id": 37317,
                        "name": "Lewis A. vs Beaton S.",
                        "status": "upcoming",
                        "duration": 9000,
                        "league_id": 3276,
                        "season_id": 19014,
                        "start_time": "2009-10-30T19:00:00\u002B00:00",
                        "league_name": "European Darts Championship",
                        "season_name": "European Championship 2009",
                        "away_team_id": 47611,
                        "home_team_id": 47470,
                        "status_reason": "Ended",
                        "tournament_id": 66472,
                        "away_team_name": "Beaton S.",
                        "home_team_name": "Lewis A.",
                        "away_team_score": 6,
                        "home_team_score": 2,
                        "tournament_name": "European Championship",
                        "league_hash_image": "dce48e5a22edb035ca876820a31dab40157d96707c1f7e3e279749780b4762a9",
                        "away_team_hash_image": "0ffe770ea7b246ea3bc0953535cc8ef940f9091d6f4d9b76071d55ca9e73988f",
                        "home_team_hash_image": "40764b0d8431f697fe9bebf5168ca2f98a3587d2448156eb633df20ba65d14b5",
                        "tournament_importance": 0
                    },
                    {
                        "id": 37319,
                        "name": "Wade J. vs Tabern A.",
                        "status": "finished",
                        "duration": 9000,
                        "league_id": 3276,
                        "season_id": 19014,
                        "start_time": "2009-10-30T19:00:00\u002B00:00",
                        "league_name": "European Darts Championship",
                        "season_name": "European Championship 2009",
                        "away_team_id": 47597,
                        "home_team_id": 47448,
                        "status_reason": "Ended",
                        "tournament_id": 66472,
                        "away_team_name": "Tabern A.",
                        "home_team_name": "Wade J.",
                        "away_team_score": 4,
                        "home_team_score": 6,
                        "tournament_name": "European Championship",
                        "league_hash_image": "dce48e5a22edb035ca876820a31dab40157d96707c1f7e3e279749780b4762a9",
                        "away_team_hash_image": "87a07593b77f25fe6a962f4d0985e610219f9785828a039dc5036a3f25bdbfa8",
                        "home_team_hash_image": "8405cdc2cc83067a1165e3cb65baed4e3b543f5dca9fd88d85a2b188b031b3d5",
                        "tournament_importance": 0
                    },
                ]

                return
            }

            this.error = false
            this.loading = true
            this.fixturesData = [];

            fetch(`https://${HOST}/matches-by-date?limit=500&date=eq.${this.selectedDate}`, {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.length) {
                        this.fixturesData = data[0].matches
                    }
                })
                .catch((err) => {
                    console.error('ERROR IN FETCH MATCHES', err);
                    console.error(err.message);
                    // this.error = 'Something went wrong while fetching details. Try again later.'
                    this.error = err.message

                })
                .finally(() => {
                    this.loading = false
                });
        },
        // Datepicker
        initDatepickerSwiper() {
            this.datepickerSwiper = new Swiper('.js-datepicker-single', {
                modules: [Navigation],
                spaceBetween: 0,
                initialSlide: DATES_INTERVAL,
                allowTouchMove: false,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })

            this.datepickerSwiper.on('activeIndexChange', () => {
                this.selectedDate = this.dates[this.datepickerSwiper.activeIndex].value
                this.selectedDate = this.dates[this.datepickerSwiper.activeIndex].value
                this.getFixtures()
            });
        },
        setActiveSlide(index) { // template @click event
            this.datepickerSwiper.slideTo(index)
        },
    },
    created() {
        // Get Query params
        this.dateQueryParam = urlParams.get('date');

       const widgetEl = document.querySelector('#fixtures');
       const loaderEl = document.querySelector('#fixtures-loader');

       if (widgetEl) {
           widgetEl.classList.remove('hide')
       }
       if (loaderEl) {
           loaderEl.classList.add('hide')
       }

        this.today = moment().format(this.dateFormat);
        this.dates = this.getDateRange(DATES_INTERVAL);
        this.selectedDate = this.dateQueryParam ? this.dateQueryParam : this.today;
        this.getFixtures()
    },
    async mounted() {
       await this.$nextTick();
       this.initDatepickerSwiper();
       await this.$nextTick();

        if (this.dateQueryParam) {
            const index = this.dates.findIndex((item) => item.value === this.dateQueryParam)
            this.setActiveSlide(index);
            this.dateQueryParam = null;
        }
    },
}